angular.module('app').factory('casinoGroupService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        let restAngular = Restangular.withConfig(function (config) {
            config.setBaseUrl(settings.apiURL);
        }).all("/CasinoGroup/");

        return {
            get: function (requestData) {
                return restAngular.one("get").customGET(param(requestData))
            },
            getGroupSkinsList: function (requestData) {
                return restAngular.one("getGroupSkinList").customGET(param(requestData))
            },
            switchSkins: function (requestData) {
                return restAngular.one("switchSkins").post("", requestData)
            }
        }
    }
]);
